import Color from "color";

import { palette, spacing } from "../../styles";
import type { TypographyTypes, TypographyVariants } from "../Typography/variants";
import type { ButtonTypes } from "./types";

const link = {
  backgroundColor: palette.common.transparent,
  marginVertical: 0,
  marginHorizontal: 0,
  minHeight: spacing.unit * 2,
};

const inlineLink = {
  backgroundColor: palette.common.transparent,
  marginVertical: 0,
  minHeight: 0,
  paddingHorizontal: spacing.unit / 2,
};

export const buttonTypes = {
  primary: {
    backgroundColor: palette.primary.accent,
    borderRadius: spacing.radius,
  },
  secondary: {
    backgroundColor: palette.common.white,
    borderRadius: spacing.radius,
    borderWidth: 1,
  },
  tertiary: {
    backgroundColor: palette.tertiary.accent,
    borderRadius: spacing.radius,
  },
  quaternary: {
    backgroundColor: palette.secondary.main,
    borderRadius: spacing.radius,
  },
  error: {
    backgroundColor: palette.font.error,
    borderRadius: spacing.radius,
  },
  link,
  accentLink: link,
  errorLink: {
    ...link,
    textDecorationLine: "underline",
    textDecorationColor: palette.font.error,
  },
  secondaryLink: link,
  inlineLink,
  smallInlineLink: inlineLink,
  transparent: {
    backgroundColor: palette.common.transparent,
    borderRadius: spacing.radius,
  },
} as const;

export const buttonVariants = {
  default: {},
  small: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "center",
    minHeight: spacing.unit * 4.75,
    maxHeight: spacing.unit * 5.5,
    paddingHorizontal: spacing.unit * 2,
  },
} as const;

export const rippleColors = {
  primary: Color(palette.primary.main).alpha(0.2).string(),
  secondary: Color(palette.secondary.main).alpha(0.2).string(),
  default: Color(palette.common.black).alpha(0.2).string(),
} as const;

export const buttonTypographyVariantMapping: {
  [key in ButtonTypes]: TypographyVariants;
} = {
  primary: "button",
  secondary: "button",
  link: "buttonLink",
  secondaryLink: "link",
  accentLink: "buttonLink",
  inlineLink: "link",
  smallInlineLink: "smallLink",
  error: "buttonLink",
  errorLink: "button",
  tertiary: "button",
  quaternary: "button",
  transparent: "button",
};

export const buttonTypographyTypeMapping: {
  [key in ButtonTypes]: TypographyTypes;
} = {
  inlineLink: "primaryLink",
  smallInlineLink: "primaryLink",
  link: "accentLink",
  secondaryLink: "secondaryLink",
  accentLink: "accentLink",
  primary: "white",
  error: "white",
  errorLink: "error",
  secondary: "primary",
  tertiary: "white",
  quaternary: "primary",
  transparent: "primary",
};
